import { render, staticRenderFns } from "./HornoComponent.vue?vue&type=template&id=67c0f717&scoped=true"
import script from "./HornoComponent.vue?vue&type=script&lang=js"
export * from "./HornoComponent.vue?vue&type=script&lang=js"
import style0 from "./HornoComponent.vue?vue&type=style&index=0&id=67c0f717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0f717",
  null
  
)

export default component.exports